import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Menu, MenuItem, Typography, useTheme } from '@material-ui/core';

import { FiChevronDown } from 'react-icons/fi';

import { colors } from '../../theme/colors';

import { Flex } from '../Flex';

function SortFilter({ options, onClick }) {
  const muiTheme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState(options[0].label);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClickItem(item) {
    setSelectedOption(item.label);
    onClick(item.value);
    setAnchorEl(null);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <Flex directionRow alignCenter justifyContentCenter>
      <Typography
        variant="body2"
        style={{
          fontWeight: muiTheme.typography.fontWeightRegular,
          color: colors.gray3,
        }}
      >
        Ordenar por:
      </Typography>
      <Box ml={1} onClick={handleClick} data-testid="select-clickable">
        <Flex directionRow alignCenter cursorPointer>
          <Typography
            variant="body2"
            style={{ fontWeight: muiTheme.typography.fontWeightMedium }}
            data-testid="select-label"
          >
            {selectedOption}
          </Typography>
          <Flex ml={1} alignCenter justifyCenter>
            <FiChevronDown />
          </Flex>
        </Flex>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        data-testid="options-menu"
      >
        {options.map(item => (
          <MenuItem
            key={item.id}
            onClick={() => handleClickItem(item)}
            data-testid={`option-${item.value}`}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Flex>
  );
}

SortFilter.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  onClick: PropTypes.func.isRequired,
};

SortFilter.defaultProps = {
  options: [
    {
      id: 0,
      label: '',
      value: '',
    },
  ],
  onClick: () => {},
};

export { SortFilter };
